import type { ChildDom } from "vanjs-core";
import { reactive } from "vanjs-ext";
import { article, button, div, p, section } from "./van-tags";
import { scrollIntoView, type ViewComponent } from "./view-component";

/**
 * It is recommended to attach the ChildDom at the bottom so that other view
 * components do not jump when the notification is cleared.
 */
export class ErrorSection implements ViewComponent {
	// Sets visibility to hidden.
	clear(): void {
		this.#reactive.text = "";
	}

	// Set the displayed text and scroll the notification into view.
	setText(text: string): void {
		this.#reactive.text = text;
		scrollIntoView(this.ChildDom);
	}

	#reactive = reactive({
		text: "",
	});

	ChildDom: ChildDom;

	constructor() {
		this.ChildDom = section(
			{ class: "section" },
			article(
				{
					class: () =>
						this.#reactive.text ? "message is-danger" : "is-hidden",
				},
				div(
					{ class: "message-header" },
					p("Error"),
					button({
						class: "delete",
						onclick: () => this.clear(),
					}),
				),
				div({ class: "message-body" }, () => this.#reactive.text),
			),
		);
	}
}
